import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgPinterestIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.613.072c-.55.058-1.28.165-1.679.241A15.96 15.96 0 0 0 1.701 8.862C.832 10.589.345 12.227.11 14.214c-.089.743-.102 2.704-.026 3.42.461 4.242 2.475 7.984 5.756 10.714a18.87 18.87 0 0 0 2.35 1.611c.693.385 1.91.949 1.955.904.009-.009-.005-.215-.031-.456-.08-.739-.108-2.444-.05-3.04.068-.697.068-.684 1.124-5.16l.904-3.822-.157-.474c-.42-1.276-.407-2.708.036-3.804.55-1.36 1.678-2.144 2.846-1.978.434.062.77.223 1.061.505.434.421.636.972.636 1.732 0 .716-.126 1.271-.734 3.294-.65 2.144-.712 2.484-.591 3.062.098.465.268.778.609 1.123.474.479 1.065.712 1.803.712 2.448 0 4.377-2.234 4.892-5.662.112-.743.116-2.336.009-2.909-.193-1.016-.622-2.027-1.173-2.757-.555-.738-1.423-1.432-2.269-1.826-1.4-.644-3.16-.828-4.797-.492-2.892.586-5.018 2.802-5.47 5.702-.103.649-.071 1.83.059 2.394.196.832.563 1.683.935 2.18.107.143.206.308.224.367.04.16-.466 2.17-.569 2.264-.313.282-1.597-.698-2.296-1.745-.917-1.388-1.44-3.267-1.351-4.879.138-2.569 1.11-4.775 2.833-6.426C9.945 7.5 11.533 6.673 13.47 6.243c1.558-.344 3.59-.38 5.044-.09 4.113.833 7.085 3.89 7.604 7.829.099.751.067 2.287-.067 3.065-.318 1.844-.994 3.473-1.996 4.816-.318.425-1.092 1.235-1.5 1.566a7.756 7.756 0 0 1-3.258 1.549c-.653.134-1.638.161-2.184.063a5.473 5.473 0 0 1-1.62-.569c-.385-.22-.949-.725-1.137-1.016-.067-.112-.125-.188-.125-.17 0 .099-1.092 4.153-1.204 4.471-.29.81-.962 2.175-1.562 3.16-.107.179-.188.34-.17.353.058.059 1.397.38 2.019.484 1.002.165 1.49.201 2.68.201 1.93 0 3.527-.26 5.192-.837a15.648 15.648 0 0 0 5.953-3.678c2.609-2.556 4.189-5.698 4.708-9.359.112-.792.134-2.842.044-3.706-.232-2.175-.84-4.148-1.861-6.024A16.007 16.007 0 0 0 19.258.354C18.153.125 17.674.08 16.201.067a49.313 49.313 0 0 0-1.588.005Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgPinterestStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgPinterestIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const PinterestIcon: any = SvgPinterestStyle;
export default PinterestIcon;
